import { getElement, getElements, ifSelectorExist } from "./utils";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

export const downloadPdfCoupon = () => {
  const allCoupons = getElements(".printed_coupon");
  if (ifSelectorExist(allCoupons)) {
    Array.from(allCoupons).forEach((coupon) => {
      let printButtonSelector = getElement(".allow_print", coupon);
      if (ifSelectorExist(printButtonSelector)) {
        printButtonSelector.addEventListener("click", (e) => {
          e.preventDefault();
          let prevText = printButtonSelector.textContent;
          printButtonSelector.textContent = 'Loading...';

          html2canvas(coupon)
            .then((canvas) => {
              var imgData = canvas.toDataURL("image/png");
              var pdf = new jsPDF("p", "mm", "a4"); // use 'p' for portrait mode, 'mm' for size in millimeters, and 'a4' for paper format

              var imgWidth = pdf.internal.pageSize.getWidth();
              var pageHeight = pdf.internal.pageSize.getHeight();
              var imgHeight = (canvas.height * imgWidth) / canvas.width;
              var heightLeft = imgHeight;

              var position = 0;

              // calculate X and Y to center image
              var x = (pdf.internal.pageSize.getWidth() - imgWidth) / 2;
              var y = (pdf.internal.pageSize.getHeight() - imgHeight) / 2;

              pdf.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);
              heightLeft -= pageHeight;

              while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", x, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
              }

              pdf.save("coupon.pdf");
              printButtonSelector.textContent = prevText;
            })
            .catch(function (error) {
              console.error("oops, something went wrong!", error);
            });
        });
      }
    });
  }
};
